module.exports = {"closeButtonText":"Закрыть","thumbNailAlt":"Предпросмотр изображения","next":"Следующая страница","previous":"Предыдущая страница","addNote":"Добавить примечание..."}


//////////////////
// WEBPACK FOOTER
// ./translations/ru.json
// module id = 38
// module chunks = 0